import React, { useEffect, useState } from "react";
import { getMembers } from "../../api/careTeamApi"; 
import InfoCard from "./InfoCard";

const CareTeamCard = () => {
  const [careTeam, setCareTeam] = useState([]);
  const userId = localStorage.getItem("userId");

  useEffect(() => {
    const fetchTeam = async () => {
      try {

        if (!userId) {
          return;
        }

        const data = await getMembers(userId);
        setCareTeam(data);
      } catch (error) {
        console.error("Error fetching care team:", error);
      }
    };

    fetchTeam();
  }, [userId]);

  return (
    <InfoCard title="Care Team">
      {careTeam.length === 0 ? (
        <p className="text-gray-500">No care team members assigned.</p>
      ) : (
        careTeam.map((member, i) => (
          <p key={i}>
            {member.name} – {member.role}
          </p>
        ))
      )}
    </InfoCard>
  );
};

export default CareTeamCard;
